package one.healthium.uscreen.ui.util

import one.healthium.uscreen.domain.models.StyledTextModel

private val placeholderRegex = """\{([^}|]+)(?:\|\|([^}]*))?\}""".toRegex()

fun String.resolvePlaceholders(placeholders: Map<String, String>): String {
    if (!contains('{')) return this
    return placeholderRegex.replace(this) { match ->
        val key = match.groupValues[1]
        val default = match.groupValues[2]
        placeholders[key] ?: default.ifEmpty { match.value }
    }
}

fun StyledTextModel.resolvePlaceholders(placeholders: Map<String, String>): StyledTextModel {
    if (placeholders.isEmpty()) return this
    return StyledTextModel(
        segments = segments.map { segment ->
            when (segment) {
                is StyledTextModel.StyledSegment.Plain ->
                    StyledTextModel.StyledSegment.Plain(segment.text.resolvePlaceholders(placeholders))
                is StyledTextModel.StyledSegment.Styled ->
                    segment.copy(text = segment.text.resolvePlaceholders(placeholders))
            }
        },
    )
}
